import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

@Component({

   selector: 'page-print',
   templateUrl: 'print.html'
})

export class PrintPage
{

   private activeIdx = [];
   private handler;


   /** ----- Constructor ----- **/

   constructor( private params: NavParams,
                private viewCtrl: ViewController )
   {

      this.handler = this.params.get( 'handler' );

   }


   /** ----- UI Callbacks ----- **/

   onNextBtnClicked()
   {

      if ( this.handler != null )
      {
         this.handler().then( res => {

            this.viewCtrl.dismiss();
         });
      }
      else
      {
         this.viewCtrl.dismiss();
      }

   }


   onBtnClicked( inIdx )
   {

      // if index already active
      if ( this.activeIdx.indexOf( inIdx ) > -1 )
      {
         // remove from active
         this.activeIdx.splice( this.activeIdx.indexOf( inIdx ), 1 );
      }
      else
      {
         // add to active
         this.activeIdx.push( inIdx );
      }

   }

}



// WEBPACK FOOTER //
// ./src/pages/print/print.ts